import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { qualityFeatures } from "@/mocks/home";

const tiers = [
  {
    id: "t1",
    name: "高清 720P",
    res: "1280 × 720",
    device: "手机、平板",
    net: "2 Mbps 起",
    note: "流量有限时的稳妥选择，画面够用且加载最轻。",
  },
  {
    id: "t2",
    name: "蓝光 1080P",
    res: "1920 × 1080",
    device: "笔记本、显示器",
    net: "5 Mbps 起",
    note: "默认档位，细节与体积平衡，适合大多数屏幕。",
  },
  {
    id: "t3",
    name: "4K HDR",
    res: "3840 × 2160",
    device: "电视、投屏",
    net: "15 Mbps 起",
    note: "大屏场景首选，暗部与高光层次最完整。",
  },
];

export default function QualitySection() {
  return (
    <section id="quality" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="高清画质"
            title="蓝光起步，画质随网络自动匹配"
            desc="清晰度不是越高越好，而是要和屏幕尺寸、网络状况一起看。下面先说清楚每种清晰度适合什么场景，再列出蓝光播放依赖的几项画质能力。"
          />
        </Reveal>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4">
          {tiers.map((tier, index) => (
            <Reveal key={tier.id} delay={index * 80}>
              <article className="h-full rounded-lg bg-background-100 border border-background-200 p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{tier.name}</h3>
                <dl className="mt-4 space-y-2 text-sm">
                  <div className="flex justify-between gap-3">
                    <dt className="text-foreground-500">分辨率</dt>
                    <dd className="text-foreground-900">{tier.res}</dd>
                  </div>
                  <div className="flex justify-between gap-3">
                    <dt className="text-foreground-500">适合设备</dt>
                    <dd className="text-foreground-900">{tier.device}</dd>
                  </div>
                  <div className="flex justify-between gap-3">
                    <dt className="text-foreground-500">建议网络</dt>
                    <dd className="text-foreground-900">{tier.net}</dd>
                  </div>
                </dl>
                <p className="mt-4 pt-4 border-t border-background-300 text-sm text-foreground-700 leading-relaxed">
                  {tier.note}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {qualityFeatures.map((feature, index) => (
            <Reveal key={feature.id} delay={(index % 3) * 70}>
              <div className="h-full flex gap-4 rounded-lg bg-background-100/70 border border-background-200 p-4">
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${feature.icon} text-lg`}></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950">{feature.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}